module.exports = __webpack_public_path__ + "asset/bastion--e3f374.svg";